import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import Navigation from '../../Commons/Navigation/Navigation'
import './GameBuilder.scss'
import Footer from '../../Commons/Footer/Footer'
import { useEffect, useRef, useState } from 'react'
import { gameFileInfoData, gameFileTest, layoutTypeInfoData } from './Commons'
import { v4 as uuidv4 } from 'uuid';
import GameFileBuilder from './GameFileBuilder'
import CardFileBuilder from './CardFileBuilder/CardFileBuilder'
import DeckTopSection from '../../DeckBuilder/Decks/DeckTopSection'
import { FeedbackButton } from '../../Commons/Functions'

export default function GameBuilder() {
    const [currentPage, setCurrenPage] = useState("INTRO")

    const ReturnButton = (
        <Button className="position-absolute start-0 top-0" style={{ translate: "0 -120%" }} onClick={() => {
            setCurrenPage("INTRO")
        }}>Return</Button>
    )

    return (
        <div className="w-100 game-build">
            <Navigation currentPage="Build" />
            {currentPage == "INTRO" && (<Intro setCurrenPage={setCurrenPage} />)}
            {currentPage == "GAME_FILE" && (<GameFileBuilder returnButton={ReturnButton} />)}
            {currentPage == "CARD_FILE" && (<CardFileBuilder returnButton={ReturnButton} />)}
            <Footer></Footer>
        </div>
    )
}

function Intro(props) {
    const [gameLink, setGameLink] = useState(false)

    function encodeURL(url) {
        return btoa(encodeURIComponent(url));
    }

    return (
        <>
            <DeckTopSection>
                <h1>Game build</h1>
            </DeckTopSection>
            <div className="below-navbar">
                <Container className="p-5 pt-0 position-relative" style={{ minHeight: "85vh" }}>
                    <div className='text-start'>
                        <p className='mt-5'>To play your own game in this app, you will need 3 things:<br />
                            - A <b>game file</b> in the .json format hosted on the website of your choice. You can create or edit it using the <b>game file</b> button below.<br />
                            - A <b>card list file</b> in the .json format hosted on the website of your choice. You can create or edit it using the <b>card list file</b> button below.<br />
                            - <b>Card images</b> hosted on the website of your choice. <br />
                            - (optional) a file containing <b>starter decklists</b> hosted on the website of your choice. Build your game first to easily create decks, you'll make this file later.<br />
                            <br />
                            Check the Discord to find more about the recommended way to host those files for free.
                        </p>


                        <div className='d-flex justify-content-start align-items-center mt-5'><h1 className='me-5'>1.</h1><p>Upload all you images (card, tokens, playmats and game banner) in the host of your choice.</p></div>

                        <div className='d-flex justify-content-start align-items-center'><h1 className='me-5'>2.</h1>
                            <p className='w-50'>Create, download and upload the file containing the list of cards. Once you understand the structure of the file you can create and update it using a script.</p>
                            <div className='row w-50 ms-auto'>
                                <Button onClick={() => props.setCurrenPage("CARD_FILE")} className="w-100" size="lg">Card list file</Button>
                            </div>
                        </div>

                        <div className='d-flex justify-content-start align-items-center'><h1 className='me-5'>3.</h1>
                            <p className='w-50'>Create, download and upload the main game file.</p>
                            <div className='row w-50 ms-auto'>
                                <Button onClick={() => props.setCurrenPage("GAME_FILE")} className="w-100" size="lg">Game file</Button>
                            </div>
                        </div>

                        <div className='d-flex justify-content-between align-items-start'>
                            <h1 className='me-5'>4.</h1>
                            <div className='box-container flex-column mx-0 overflow-hidden w-100'>
                                <p>Enter the url to your game file to generate a link that will let players enjoy your game.</p>
                                <div className='d-flex'>
                                    <Form.Control
                                        type="text"
                                        id="game-image"
                                        className='my-3'
                                        placeholder={"https://Game_MyGame.json"}
                                        defaultValue={""}
                                        onChange={(e) => {
                                            let url = e.currentTarget.value
                                            if (url != "") {
                                                const baseUrl = "https://tcg-arena.fr/load/"
                                                //baseUrl = "192.168.1.4:3000/load/"
                                                setGameLink(baseUrl + encodeURL(url))
                                            } else {
                                                setGameLink(false)
                                            }
                                        }}
                                    />
                                </div>
                                <div className='d-flex justify-content-between'>
                                    <p className='me-3 my-auto text-nowrap'>Your link:</p>
                                    {gameLink && (<p className='my-auto text-break overflow-hidden me-auto' style={{ maxWidth: "85%" }}><b>{gameLink}</b></p>)}
                                    <FeedbackButton className="my-auto" feedBack={"Copied !"} onClick={() => {
                                        navigator.clipboard.writeText(gameLink).then(function () {
                                        }).catch(function (err) {
                                            console.error("Erreur lors de la copie : ", err);
                                        });
                                    }}>Copy</FeedbackButton>
                                </div>
                            </div>
                        </div>

                        <div className='d-flex justify-content-start align-items-center'><h1 className='me-5'>5.</h1><p>Share your link to other players!</p></div>

                        <div className='d-flex justify-content-start align-items-center'><h1 className='me-3'>(6.)</h1><p>If you want to update your game, those file are readable and easy to modify with a text editor. But if you prefer, you can always import them here to make the changes. </p></div>

                    </div>
                </Container>
            </div>
        </>
    )
}

function GameFileIni() {
    return (
        <div>
            <Button>New</Button>
            <Button>Import</Button>
        </div>
    )
}